import { getViewportForBounds, useReactFlow } from '@xyflow/react';
import type { toPng } from 'html-to-image';
import { forwardRef, useImperativeHandle } from 'react';
import { FamilyTree } from '../../../../family-tree';
import { useWealthPlanningNavigate } from '../../../hooks/useWealthPlanningNavigate';

export interface IClientPackageFamilyTreeRef {
    getFamilyTreeOptions: (width: number, height: number) => Parameters<typeof toPng>[1];
}

export const ClientPackageFamilyTree = forwardRef<IClientPackageFamilyTreeRef>((_, ref) => {
    const { partnerUuid } = useWealthPlanningNavigate();
    const { getNodes, getNodesBounds } = useReactFlow();

    useImperativeHandle(
        ref,
        () => ({
            getFamilyTreeOptions(width, height): Parameters<typeof toPng>[1] {
                const nodes = getNodes();
                const nodesBounds = getNodesBounds(nodes);
                const hasValidBounds = nodes.length > 0 && nodesBounds.width > 0 && nodesBounds.height > 0;
                const viewport = hasValidBounds ? getViewportForBounds(nodesBounds, width, height, 0.5, 2, '48px') : { x: 0, y: 0, zoom: 1 };

                return {
                    backgroundColor: '#ffffff',
                    width,
                    height,
                    style: {
                        width: `${width}px`,
                        height: `${height}px`,
                        transform: `translate(${viewport.x}px, ${viewport.y}px) scale(${viewport.zoom})`,
                    },
                };
            },
        }),
        [getNodes, getNodesBounds],
    );

    return (
        <div style={{ position: 'relative', display: 'flex', width: '100%', height: '100%' }}>
            <FamilyTree partnerUuid={partnerUuid} isPresentationMode={true} setPresentationMode={() => null} isPrintMode={true} />
        </div>
    );
});
